angular.module('zc.projects')

.controller 'ConfirmCampaignCtrl', ($scope, $translate, Page, Campaign, campaign, currentProject, templates) ->
  Page.setBodyClass ''
  $translate('projectsCampaigns.confirmController.campaignSetting').then (translation) ->
    Page.setTitle translation

  $scope.campaign = campaign
  if $scope.campaign.template_type
    template = _.find templates,
      name: $scope.campaign.template_type
    if template
      $scope.campaign.template = template

  $scope.previewUrl = Campaign.previewUrl(currentProject.base_url, campaign)



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/confirm.controller.coffee